import classNames from 'classnames';
import { bool, func, string } from 'prop-types';

import ButtonPlain from '~/components/ButtonPlain';

import useBooleanState from '~/hooks/useBooleanState';
import useMountedRef from '~/hooks/useMountedRef';

import styles from './ButtonPlainPromised.module.scss';

export default function ButtonPlainPromised({
  onClick,
  processingClassName,
  className,
  disabled,
  ...props
}) {
  const mounted = useMountedRef();
  const [
    processing,
    { setTrue: setProcessingTrue, setFalse: setProcessingFalse },
  ] = useBooleanState();

  const onClickWrapped = async (event) => {
    try {
      setProcessingTrue();
      await Promise.resolve(onClick(event));
    } finally {
      if (mounted.current) {
        setProcessingFalse();
      }
    }
  };

  return (
    <>
      <ButtonPlain
        className={classNames(
          className,
          processing && classNames(styles.processing, processingClassName),
        )}
        onClick={onClickWrapped}
        disabled={processing || disabled}
        {...props}
      />
    </>
  );
}

export const propTypes = {
  processingClassName: string,
  onClick: func,
  className: string,
  disabled: bool,
};

ButtonPlainPromised.propTypes = propTypes;
